import * as AvatarActions from '../actionTypes/avatar';

export function hideAvatarForMessage(messageId) {
    return {
        type: AvatarActions.HIDE_AVATAR_FOR_MESSAGE,
        messageId,
    };
}

export function showAvatarForMessage(messageId) {
    return {
        type: AvatarActions.SHOW_AVATAR_FOR_MESSAGE,
        messageId,
    };
}
